"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconLink = function IconLink(_ref) {
  var item = _ref.item,
      variant = _ref.variant,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_styled.LargeLink, {
    href: item.url // eslint-disable-next-line react/prop-types
    ,
    target: item.openInNewTab ? "_blank" : "",
    variant: variant
  }, children);
};

IconLink.propTypes = {
  item: _propTypes.default.shape({
    url: _propTypes.default.string,
    alignIconToTop: _propTypes.default.bool,
    color: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    imgWidth: _propTypes.default.number
  }),
  variant: _propTypes.default.string,
  children: _propTypes.default.node
};

var MenuItems = function MenuItems(_ref2) {
  var items = _ref2.items,
      variant = _ref2.variant,
      size = _ref2.size;

  if (size === "large") {
    return items.map(function (item, i) {
      return /*#__PURE__*/_react.default.createElement(IconLink, {
        key: i,
        item: item,
        variant: variant
      }, /*#__PURE__*/_react.default.createElement(_styled.ImageContainer, null, item.img), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styled.LinkTitle, {
        $color: item.color
      }, item.label), /*#__PURE__*/_react.default.createElement(_styled.LinkSub, null, item.sub)));
    });
  }

  return items.map(function (item, i) {
    if (item.onClick) {
      return /*#__PURE__*/_react.default.createElement(_styled.EventLink, {
        onClick: item.onClick,
        color: item.color,
        hoverColor: item.hoverColor,
        key: i,
        variant: variant
      }, /*#__PURE__*/_react.default.createElement(_styled.SvgIconContainer, null, item.icon), item.label);
    }

    return /*#__PURE__*/_react.default.createElement(_styled.Link, {
      href: item.url,
      key: i,
      variant: variant,
      target: item.openInNewTab ? "_blank" : ""
    }, /*#__PURE__*/_react.default.createElement(_styled.SvgIconContainer, null, item.icon), item.label);
  });
};

var Menu = function Menu(_ref3) {
  var label = _ref3.label,
      labelColor = _ref3.labelColor,
      disabled = _ref3.disabled,
      items = _ref3.items,
      variant = _ref3.variant,
      size = _ref3.size,
      position = _ref3.position,
      avatarElement = _ref3.avatarElement,
      showAvatar = _ref3.showAvatar,
      className = _ref3.className;
  return /*#__PURE__*/_react.default.createElement(_styled.Container, {
    disabled: disabled,
    className: className,
    size: size
  }, /*#__PURE__*/_react.default.createElement(_styled.Label, {
    variant: variant,
    labelColor: labelColor
  }, showAvatar && avatarElement, " ", label, " ", /*#__PURE__*/_react.default.createElement(_styled.Icon, null)), /*#__PURE__*/_react.default.createElement(_styled.Dropdown, {
    variant: variant,
    size: size,
    position: position
  }, /*#__PURE__*/_react.default.createElement(MenuItems, {
    items: items,
    variant: variant,
    size: size
  })));
};

Menu.propTypes = {
  label: _propTypes.default.string.isRequired,
  labelColor: _propTypes.default.string,
  items: _propTypes.default.array.isRequired,
  variant: _propTypes.default.oneOf(["light", "dark"]),
  size: _propTypes.default.oneOf(["normal", "large"]),
  position: _propTypes.default.oneOf(["left", "right"]),
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  showAvatar: _propTypes.default.bool,
  avatarElement: _propTypes.default.any
};
Menu.defaultProps = {
  variant: "light",
  size: "normal",
  position: "right",
  disabled: false
};
var _default = Menu;
exports.default = _default;